<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card no-body class="orcamento-editar-card">
            <orcamento-loading :active="processoCarregamento" :steps="etapasCarregamento" />
            <div v-if="!processoCarregamento">

          <orcamento-cabecalho
            :id="$store.state.orcamento.dados.id"
            :codigo="$store.state.orcamento.dados.id"
            :status="orcamentoStatus"
            :razao-social="clientBasicInfo.razao_social"
            :status-cliente="clientBasicInfo.status"
            :data-emissao="$store.state.orcamento.dados.data_emissao"
            :data-validade="infoOrcamento.data_validade"
            :previsao-fechamento="infoOrcamento.previsao_fechamento"
            :contato="infoOrcamento.contato"
            :cnpj="clientBasicInfo.cnpj"
            :show-duplicar="true"
            :show-imprimir="podeImprimirOrcamento"
            @voltar="voltarOrcamentos"
            @duplicar="duplicarOrcamento"
            @imprimir="printOrcamento"
          >
            <template v-if="podeAlterarOrcamento" #previsao>
              <b-form-input
                id="previsao_fechamento"
                :type="'date'"
                v-model="infoOrcamento.previsao_fechamento"
                placeholder="Previsão de Fechamento"
                @blur="alteraPrevFechamento()"
              />
            </template>
            <template v-if="podeAlterarOrcamento" #contato>
              <b-form-input
                id="contato"
                type="text"
                v-model="infoOrcamento.contato"
                placeholder="Contato"
              />
            </template>
          </orcamento-cabecalho>
          <b-card-body class="orcamento-editar-card__body">
            <template v-if="!productsVisible">
              <b-row>
                <b-col>
                  <orcamento-itens-tabela
                    :items="orcamentoItens"
                    :filial="getFilial()"
                    :modo-edicao="orcamentoEstaModoEdicao"
                    :loading="carregandoItensOrcamento"
                    :itens-alterados="itensAlterados"
                    :sort-by.sync="sortBy"
                    :sort-direction.sync="sortDirection"
                    :get-comissao-fn="getValorComissao"
                    @sort-changed="onSortChanged"
                    @edit="editBudgetItem"
                    @delete="confirmDeleteItem"
                    @add-products="showProducts"
                  >
                    <template #alerta="{ item }">
                      <orcamento-item-alerta
                        :key="item.id"
                        :id="'orcamentoItemAlertaID' + item.id"
                        v-if="orcamentoEstaModoEdicao"
                        :orcamentoId="item.orcamento_id"
                        :orcamentoItemId="item.id"
                        :alertas="montarAlertasItem(item)"
                      ></orcamento-item-alerta>
                    </template>
                  </orcamento-itens-tabela>
                  <orcamento-avisos></orcamento-avisos>
                  <div class="aceite-informacoes-orcamento">
                    <b-form-checkbox
                      id="bo_aceite_informacoes_orcamento"
                      class="aceite-informacoes-orcamento__checkbox"
                      v-model="infoOrcamento.bo_aceite_informacoes_orcamento"
                      value="S"
                      unchecked-value="N"
                      :disabled="!orcamentoEstaModoEdicao || salvandoAceiteInformacoes"
                      :state="aceiteInformacoesState"
                      @change="onAceiteInformacoesChange"
                    >
                      Li as informações acima e estou de acordo
                    </b-form-checkbox>
                    <small
                      v-if="aceiteInformacoesState === false"
                      class="aceite-informacoes-orcamento__error"
                    >
                      O campo "Li as informações acima e estou de acordo" é obrigatório.
                    </small>
                  </div>
                </b-col>
              </b-row>

              <div class="orcamento-checkout" v-if="!carregandoItensOrcamento">
                <div class="orcamento-checkout__card">
                  <orcamento-informacao-adicional></orcamento-informacao-adicional>
                  <forma-pgto
                    :orcamento-modo-edicao="podeAlterarOrcamento"
                    :opcoes-pagamentos-iniciais="opcoesPagamentos"
                    :valor-total="valorTotalSum"
                  ></forma-pgto>
                </div>

                <div class="orcamento-acoes">
                  <div class="orcamento-acoes__left">
                    <b-button
                      v-if="orcamentoEstaModoEdicao"
                      class="orcamento-acoes__btn orcamento-acoes__btn--cancel"
                      v-on:click="$bvModal.show('cancelConfirm')"
                    >
                      <i class="fa fa-times-circle"></i> Cancelar Orçamento
                    </b-button>
                    <b-button
                      v-if="hasProductChanges"
                      class="orcamento-acoes__btn orcamento-acoes__btn--refresh"
                      v-on:click="confirmFixProduts"
                    >
                      <i class="fa fa-refresh"></i> Atualizar Produtos
                    </b-button>
                  </div>
                  <div class="orcamento-acoes__right">
                    <b-button
                      class="orcamento-acoes__btn orcamento-acoes__btn--send"
                      v-on:click="confirmSend"
                      :disabled="!podeEnviar"
                    >
                      <i class="fa fa-send"></i> Efetivar Pedido
                    </b-button>
                    <b-button
                      class="orcamento-acoes__btn orcamento-acoes__btn--save"
                      v-on:click="salvarOrcamento"
                      :disabled="!orcamentoEstaModoEdicao"
                    >
                      <i class="fa fa-save"></i> Salvar
                    </b-button>
                  </div>
                </div>
              </div>
            </template>
          </b-card-body>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="cancelConfirm"
      title="Atenção"
      okVariant="orcamento-confirm-ok"
      okTitle="Sim"
      @ok="confirmCancel()"
      cancelVariant="orcamento-confirm-cancel"
      cancelTitle="Não"
      @cancel="fechaModalCancel()"
      content-class="orcamento-confirm-modal"
      header-class="orcamento-confirm-modal__header"
      body-class="orcamento-confirm-modal__body"
      footer-class="orcamento-confirm-modal__footer"
      :hideHeaderClose="modal.hideHeaderClose"
      :centered="modal.centered"
    >
      <div class="confirmacao">
        Tem certeza que deseja cancelar Orçamento Nº. {{ orcamento_id }}?
      </div>
      <div class="orcamento-confirm-modal__field">
        <label for="observacao">Motivo do cancelamento (opcional)</label>
        <textarea
          v-model="motivoCancel"
          id="observacao"
          rows="3"
          maxlength="300"
          placeholder="Escreva sua mensagem aqui"
          class="form-control"
          @keyup="charCount()"
        ></textarea>
        <p class="orcamento-confirm-modal__hint">{{ tamRest }} caracteres restante</p>
      </div>
    </b-modal>
    <b-row v-if="productsVisible">
      <b-col md="12">
        <b-card no-body>
          <b-card-header v-if="!servicoBuscaAtivo">
            <span> <i class="icon-list" id="topo-lista-produtos"></i> Lista de Produtos </span>
          </b-card-header>
          <b-card-body>
            <product-list
              id="produtosList"
              ref="produtosList"
              :cd_filial="$store.state.orcamento.dados.cd_filial"
              :cliente_codigo="clientBasicInfo.codigo"
              :resultsPerPage="10"
              v-on:onAdd="onAdd"
              v-on:onAddMga="onAddMga"
              v-on:onAddItj="onAddItj"
              @alterarModoBusca="servicoBuscaAtivo = $event"
            >
              <template #segundaColuna>
                <b-btn
                  :variant="getVariant()"
                  class="d-flex justify-content-between align-items-center w-100"
                  v-on:click="hideProducts"
                >
                  <template v-if="!isAdding()">
                    <i class="icons cui-cart mr-1"></i>
                    R$ {{ valorTotalSum | money }}
                    <b-badge class="ml-1" variant="light">{{
                      QtdeTotalSum
                    }}</b-badge>
                  </template>
                  <template v-else>
                    <div class="text-center">
                      <b-spinner
                        variant="secondary"
                        label="Totalizando..."
                        small
                      ></b-spinner>
                    </div>
                  </template>
                </b-btn>
              </template>
              <template #terceiraColuna v-if="QtdeTotalSum > 0">
                <b-btn class="w-100" variant="success" v-on:click="hideProducts"
                  >Mostrar Lista de Produtos</b-btn
                >
              </template>
            </product-list>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <orcamento-item-edit
      ref="orcamentoItemEdit"
      id="orcamentoItemEdit"
      v-model="currentOrcamentoItem"
      v-on:itemSaved="onItemSaved"
      :codigoCliente="$store.state.orcamento.dados.cliente_codigo"
      :idOrcamento="$store.state.orcamento.dados.id"
    ></orcamento-item-edit>
  </div>
</template>

<style>
.orcamento-editar-card {
  border: none !important;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
}

.orcamento-editar-card__body {
  border-radius: 0 0 12px 12px;
}

.orcamento-table-card-body {
  overflow: scroll;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0 !important;
  font-size: 12px;
}
.orcamento-footer tfoot,
.orcamento-footer tfoot > tr,
.orcamento-footer tfoot > tr > th {
  border: none;
  font-size: 0.8rem;
}
.orcamento-footer tfoot > tr > th:nth-child(12),
.orcamento-footer tfoot > tr > th:nth-child(13) {
  border: 1px solid #c8ced3;
}
.orcamento-footer tfoot > tr > th:nth-child(11),
.orcamento-footer tfoot > tr > th:nth-child(12),
.orcamento-footer tfoot > tr > th:nth-child(13) {
  text-align: right;
}
.orcamento-table-card-body tbody tr:nth-of-type(odd) .table-success {
  background-color: #cdedd8;
}
.orcamento-table-card-body tbody tr:nth-of-type(even) .table-success {
  background-color: rgba(205, 237, 216, 0.6);
}
.orcamento-table-card-body tbody tr:nth-of-type(odd) .table-info {
  background-color: #d3eef6;
}
.orcamento-table-card-body tbody tr:nth-of-type(even) .table-info {
  background-color: rgba(211, 238, 246, 0.6);
}
.orcamento-table-card-body tfoot tr th {
  background-color: white;
}
.orcamento-table-card-body tfoot tr:last-child th:hover {
  background-color: white;
}
.btn-flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.titulo-produto {
  display: flex;
  justify-content: space-between;
}
.titulo-produto-ellipsis {
  max-width: 20em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.font-12 {
  font-size: 12px !important;
}

.icone-observacao {
  border: none !important;
  background: none !important;
  color: #3131bb;
}

.div-oberervacao {
  width: 95% !important;
  margin-left: 2%;
  margin-bottom: 2%;
}

.sem-borda:focus {
  border: none;
}

.btn-primary {
  background-color: #0075eb !important;
}

.btn-warning {
  background-color: #ff6d13 !important;
  color: #fff !important;
}

.loading-texto{
  font-size: 30px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2222222e;
  font-weight: bold;
}

.updatebutton{
  display: flex;
  gap: 0.4rem;
  justify-content: center;
  background: #000;
  color: #fff;
  border-radius: 7px;
  margin-top: 4px;
  cursor: pointer;
  margin: auto;
  width: 100%;
}
.size-6{
  width: 18px;
  margin:0;
}

.aceite-informacoes-orcamento {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 0.85rem 0 1.5rem;
}

.aceite-informacoes-orcamento__checkbox.custom-control {
  display: inline-flex;
  align-items: center;
  min-height: auto;
  padding: 0.35rem 0;
  margin: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  transition: none;
}

.aceite-informacoes-orcamento__checkbox.custom-control:hover {
  border: none;
  background: transparent;
}

.aceite-informacoes-orcamento__checkbox .custom-control-label {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding-left: 0;
  padding-right: 1.85rem;
  color: #23282c;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.35;
  cursor: pointer;
}

.aceite-informacoes-orcamento__checkbox .custom-control-label::before,
.aceite-informacoes-orcamento__checkbox .custom-control-label::after {
  top: 50%;
  left: auto;
  right: 0;
  width: 1.15rem;
  height: 1.15rem;
  margin-top: 0;
  transform: translateY(-50%);
  border-radius: 4px;
}

.aceite-informacoes-orcamento__checkbox .custom-control-label::before {
  border-color: #c5ccd6;
  background: #fff;
  box-shadow: none;
}

.aceite-informacoes-orcamento__checkbox .custom-control-input:checked ~ .custom-control-label {
  color: #0075eb;
}

.aceite-informacoes-orcamento__checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #0075eb;
  background-color: #0075eb;
}

.aceite-informacoes-orcamento__checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.15rem rgba(0, 117, 235, 0.18);
}

.aceite-informacoes-orcamento__checkbox .custom-control-input:disabled ~ .custom-control-label {
  color: #8a94a6;
  cursor: not-allowed;
}

.aceite-informacoes-orcamento__checkbox.is-valid .custom-control-label::before,
.aceite-informacoes-orcamento__checkbox .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #0075eb;
}

.aceite-informacoes-orcamento__checkbox.is-invalid {
  border: none;
  background: transparent;
}

.aceite-informacoes-orcamento__checkbox.is-invalid .custom-control-label::before,
.aceite-informacoes-orcamento__checkbox .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #f5c2c7;
}

.aceite-informacoes-orcamento__checkbox.is-invalid .custom-control-label,
.aceite-informacoes-orcamento__checkbox .custom-control-input.is-invalid ~ .custom-control-label {
  color: #c62828;
}

.aceite-informacoes-orcamento__error {
  display: block;
  margin-top: 0.45rem;
  color: #c62828;
  font-size: 0.78rem;
  text-align: right;
}

.orcamento-checkout {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
}

.orcamento-checkout__card {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;
}

.orcamento-acoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.85rem 0;
  border: none;
  border-radius: 0;
  background: transparent;
}

.orcamento-acoes__left,
.orcamento-acoes__right {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.orcamento-acoes__btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 40px;
  padding: 0.45rem 0.95rem !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.orcamento-acoes__btn--cancel {
  background: #fdecee !important;
  border: 1px solid #f5c2c7 !important;
  color: #c62828 !important;
}

.orcamento-acoes__btn--cancel:hover:not(:disabled),
.orcamento-acoes__btn--cancel:focus:not(:disabled) {
  background: #f9d7db !important;
  color: #b71c1c !important;
}

.orcamento-acoes__btn--refresh {
  background: #eaf3ff !important;
  border: 1px solid #cfe2ff !important;
  color: #0075eb !important;
}

.orcamento-acoes__btn--refresh:hover:not(:disabled),
.orcamento-acoes__btn--refresh:focus:not(:disabled) {
  background: #dcecff !important;
  color: #005bb7 !important;
}

.orcamento-acoes__btn--save {
  background: #e8f7ee !important;
  border: 1px solid #b7e4c7 !important;
  color: #1b7a45 !important;
}

.orcamento-acoes__btn--save:hover:not(:disabled),
.orcamento-acoes__btn--save:focus:not(:disabled) {
  background: #d8f0e1 !important;
  color: #146338 !important;
}

.orcamento-acoes__btn--send {
  padding: 0.45rem 0.95rem !important;
  border-radius: 8px !important;
  background-color: #7C3AED !important;
  border: 1px solid #7C3AED !important;
  color: #fff !important;
}

.orcamento-acoes__btn--send:hover:not(:disabled),
.orcamento-acoes__btn--send:focus:not(:disabled) {
  background-color: #5804CA !important;
  border-color: #5804CA !important;
  color: #fff !important;
}

.orcamento-acoes__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.orcamento-confirm-modal {
  border: none !important;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18);
}

.orcamento-confirm-modal .modal-header.orcamento-confirm-modal__header {
  display: flex;
  align-items: center;
  background: #0075eb;
  border-bottom: none;
  padding: 0.9rem 1.1rem;
  color: #fff;
}

.orcamento-confirm-modal .modal-header .modal-title {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.3;
}

.orcamento-confirm-modal .modal-header .close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 1.15rem;
  font-weight: 400;
  line-height: 1;
  text-shadow: none;
  opacity: 1;
}

.orcamento-confirm-modal .modal-header .close:hover,
.orcamento-confirm-modal .modal-header .close:focus {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
  opacity: 1;
  outline: none;
}

.orcamento-confirm-modal .modal-body.orcamento-confirm-modal__body {
  padding: 1.15rem 1.1rem;
  color: #23282c;
  font-size: 0.92rem;
  line-height: 1.45;
}

.orcamento-confirm-modal .modal-footer.orcamento-confirm-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
  border-top: 1px solid #edf0f2;
  padding: 0.85rem 1.1rem 1rem;
  background: #fff;
}

.orcamento-confirm-modal__field {
  margin-top: 1rem;
}

.orcamento-confirm-modal__field label {
  display: block;
  margin-bottom: 0.4rem;
  color: #8a94a6;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.orcamento-confirm-modal__field .form-control {
  border: 1px solid #d8dee6;
  border-radius: 8px;
  font-size: 0.9rem;
  box-shadow: none;
}

.orcamento-confirm-modal__field .form-control:focus {
  border-color: #0075eb;
  box-shadow: 0 0 0 0.15rem rgba(0, 117, 235, 0.15);
}

.orcamento-confirm-modal__hint {
  margin: 0.4rem 0 0;
  color: #8a94a6;
  font-size: 0.78rem;
}

.btn-orcamento-confirm-ok {
  min-width: 72px;
  border-radius: 8px !important;
  background: #0075eb !important;
  border: 1px solid #0075eb !important;
  color: #fff !important;
  font-weight: 600;
  padding: 0.4rem 1rem;
}

.btn-orcamento-confirm-ok:hover,
.btn-orcamento-confirm-ok:focus {
  background: #005bb7 !important;
  border-color: #005bb7 !important;
  color: #fff !important;
}

.btn-orcamento-confirm-cancel {
  min-width: 72px;
  border-radius: 8px !important;
  background: #fff !important;
  border: 1px solid #d8dee6 !important;
  color: #6c757d !important;
  font-weight: 600;
  padding: 0.4rem 1rem;
}

.btn-orcamento-confirm-cancel:hover,
.btn-orcamento-confirm-cancel:focus {
  background: #f8f9fa !important;
  color: #495057 !important;
}
</style>

<script>
import "../../../assets/css/DataTableRowButton.css";
import Orcamento from "../../../services/orcamento";
import Cliente from "../../../services/cliente";
import OrcamentoAvisos from "./OrcamentoAvisos";
import OrcamentoCabecalho from "./OrcamentoCabecalho";
import OrcamentoItensTabela from "./OrcamentoItensTabela";
import OrcamentoInformacaoAdicional from "./OrcamentoInformacaoAdicional";
import OrcamentoItemEdit from "./OrcamentoItemEdit";
import OrcamentoItemAlerta from "./OrcamentoItemAlerta";
import Pedido from "../../../services/pedido";
import ProductList from "../produtos/ProductList";
import { EventBus } from "../../../helpers/eventBus";
import FormaPgto from "../FormaPgto";
import GrupoPermissao from "../../../services/grupoPermissao";
import ValidadorOrcamento from "../../../services/validadores/validadorOrcamento";
import Analytics from "../../../services/analytics";
import OrcamentoLoading from "../../../components/ui/OrcamentoLoading";

const VALOR_MINIMO_FORMA_PGTO = 250;

export default {
  name: "Orcamento",
  components: {
    OrcamentoAvisos,
    OrcamentoCabecalho,
    OrcamentoItensTabela,
    OrcamentoInformacaoAdicional,
    OrcamentoItemEdit,
    OrcamentoItemAlerta,
    ProductList,
    FormaPgto,
    OrcamentoLoading,
  },
  data: () => ({
    etapasCarregamento: [
      { key: 'orcamento', label: 'Carregando orçamento' },
      { key: 'itens', label: 'Carregando itens do orçamento' },
      { key: 'imposto', label: 'Carregando impostos e margem' },
      { key: 'cliente', label: 'Carregando dados do cliente' },
    ],
    processoCarregamento: false,
    itensAlterados: false,
    infoOrcamento: {
      bo_aceite_informacoes_orcamento: "S"
    },
    resp: "",
    productChangesReturned: 0,
    productsReturn: [],
    hasProductChanges: false,
    productsVisible: false,
    servicoBuscaAtivo: true,
    valida: false,
    show: false,
    tentouAlterarSemAceite: false,
    salvandoAceiteInformacoes: false,
    efetivandoPedido: false,
    adding: [],
    sortBy: "produto_codigo",
    exibe_observacao: false,
    sortDirection: "asc",
    contato: null,
    orcamento: new Object(),
    orcamentoItens: [],
    currentOrcamentoItem: new Object(),
    orcamento_id: null,
    clientBasicInfo: new Object(),
    tamRest: 300,
    motivoCancel: "",
    valorTotal: 0,
    vlMinimoOrcamento: 0,
    modal: {
      hideHeaderClose: false,
      centered: true,
    },
    carregandoItensOrcamento: false,
    alertasCompleta: null,
    opcoesPagamentos: null,
  }),
  computed: {
    orcamentoEstaModoEdicao() {
      return this.$store.state.orcamento.dados.status == "D" || this.$store.state.orcamento.dados.status == "S";
    },
    leuInformacoesOrcamento() {
      return this.normalizarAceiteInformacoesOrcamento(this.infoOrcamento.bo_aceite_informacoes_orcamento) == "S";
    },
    podeAlterarOrcamento() {
      return this.orcamentoEstaModoEdicao && this.leuInformacoesOrcamento && !this.salvandoAceiteInformacoes;
    },
    aceiteInformacoesState() {
      if (!this.tentouAlterarSemAceite || this.leuInformacoesOrcamento) {
        return null;
      }

      return false;
    },
    podeEnviar() {
      return (
        !this.efetivandoPedido &&
        !this.hasProductChanges &&
        this.orcamentoItens.length == this.productChangesReturned &&
        this.vlMinimoOrcamento >= 600
      );
    },
    podeImprimirOrcamento() {
      return (
        this.$store.state.orcamento.dados.status != "C" ||
        !this.valida ||
        !this.hasProductChanges
      );
    },
    valorTotalSum() {
      return this.orcamentoItens.reduce(function (total, item) {
        return total + item.valor_total * 1;
      }, 0);
    },
    QtdeTotalSum() {
      return this.orcamentoItens.reduce(function (total, item) {
        return total + item.quantidade * 1;
      }, 0);
    },
    comissaoSum() {
      let vue = this;
      const somaTotal = this.orcamentoItens.reduce(function (total, item) {
        return total + vue.getValorComissao(item);
      }, 0);
      return somaTotal 
    },
    orcamentoStatus() {
      return this.$store.state.orcamento.dados.status;
    },
  },
  watch: {
    valorTotalSum: {
      immediate: true,
      handler(valorTotal) {
        this.sincronizarValorTotal(valorTotal);
      }
    }
  },
  beforeMount() {
    this.validaPermissao();
    this.orcamento_id = this.$route.params.id;
    this.carregarOrcamento(this.orcamento_id);

    let vue = this;

    EventBus.$on("onBudgetItemHasChanges", (item) => {
      let index = vue.productsReturn.findIndex(
        (el) => el == item.orcamento_item_id
      );
      if (index == -1) {
        vue.productChangesReturned++;
        vue.productsReturn.push(item.orcamento_item_id);
      }
      if (item.changed) vue.hasProductChanges = true;
    });

    EventBus.$on("sendOrcamento", this.sendOrcamento);

    EventBus.$emit("finishLoad", {
      finish: false,
    });

    window.onbeforeunload  =  function(){
      if (vue.$store.state.ui.salvandoPedido) {
        return "";
      }
    }

    ValidadorOrcamento.setarConfiguracao(this.$helper, this.$bvModal);
  },
  methods: {
    normalizarAceiteInformacoesOrcamento(value) {
      return value == "S" || value === true || value == 1 ? "S" : "N";
    },
    validarAceiteInformacoesObrigatorio() {
      if (this.salvandoAceiteInformacoes) {
        this.$helper.showMsg(
          "Aguarde a confirmação da leitura das informações do orçamento.",
          "warning"
        );

        return false;
      }

      if (!this.orcamentoEstaModoEdicao || this.leuInformacoesOrcamento) {
        return true;
      }

      this.tentouAlterarSemAceite = true;
      this.$helper.showMsg(
        'O campo "Li as informações acima e estou de acordo" é obrigatório.',
        "warning"
      );

      return false;
    },
    async onAceiteInformacoesChange(value) {
      const valorAnterior = this.$store.state.orcamento.dados.bo_aceite_informacoes_orcamento;
      this.infoOrcamento.bo_aceite_informacoes_orcamento = this.normalizarAceiteInformacoesOrcamento(value);
      this.$store.commit('orcamento/SALVAR_DADO_ORCAMENTO', {
        bo_aceite_informacoes_orcamento: this.infoOrcamento.bo_aceite_informacoes_orcamento
      });
      this.salvandoAceiteInformacoes = true;

      try {
        await Orcamento.saveAceiteInformacoesOrcamento(
          this.$store.state.orcamento.dados.id,
          this.infoOrcamento.bo_aceite_informacoes_orcamento
        );

        this.$store.commit("orcamento/SALVAR_ORCAMENTO_ORIGINAL", Object.assign({}, this.$store.state.orcamento.dados));

        if (this.leuInformacoesOrcamento) {
          this.tentouAlterarSemAceite = false;
        }
      } catch (e) {
        this.infoOrcamento.bo_aceite_informacoes_orcamento = this.normalizarAceiteInformacoesOrcamento(valorAnterior);
        this.$store.commit('orcamento/SALVAR_DADO_ORCAMENTO', {
          bo_aceite_informacoes_orcamento: this.infoOrcamento.bo_aceite_informacoes_orcamento
        });
        this.$helper.showErrorResponse(e);
      } finally {
        this.salvandoAceiteInformacoes = false;
      }
    },
    atualizarInfoOrcamento(){
      for(let campo in this.infoOrcamento){
        let dado = {};
        dado[campo] = this.infoOrcamento[campo];
        this.$store.commit('orcamento/SALVAR_DADO_ORCAMENTO', dado);
      }
    },
    validaPermissao() {
      GrupoPermissao.getPermissao("/vendas/orcamentos").then((response) => {
        if (!response.data.data || response.data.data.edita != "1")
          this.$router.push("/");
      });
    },
    sincronizarValorTotal(valorTotal) {
      const total = valorTotal != null ? valorTotal : this.valorTotalSum;
      if (this.$store.state.orcamento.valorTotal == total) {
        return;
      }
      this.$store.commit("orcamento/ATUALIZAR_VALOR_TOTAL", total);
      EventBus.$emit("eventoAtualizarPagamento", true);
    },
    async carregarOrcamento(id) {
      this.processoCarregamento = true;
      const iniciadoEm = Date.now();

      this.orcamento = new Object();
      try {
        const response = await Orcamento.getCompleta(id)
        const data = response.data.data;

        this.orcamentoItens = data.itens || [];
        this.orcamentoItens.forEach((el) => {
          el.ultimaMargem = {
            margemValor: el.margem_valor,
            margemPercentual: el.margem_percentual,
          };
        });
        if (this.orcamentoItens.length > 0) {
          this.setarTabelapreco(this.orcamentoItens[0].cd_tabelapreco);
        } else {
          this.productsVisible = true;
        }
        this.vlMinimoOrcamento = data.valor_unitario_total;
        this.validaTabelaCoorp(this.orcamentoItens);
        this.sincronizarValorTotal(
          this.orcamentoItens.reduce((total, item) => total + item.valor_total * 1, 0)
        );
        this.carregandoItensOrcamento = false;

        this.$store.commit("orcamento/SALVAR_ORCAMENTO", data.orcamento);
        this.$store.commit("orcamento/SALVAR_ORCAMENTO_ORIGINAL", Object.assign({}, data.orcamento));
        this.infoOrcamento.data_validade = data.orcamento.data_validade;
        this.infoOrcamento.previsao_fechamento = data.orcamento.previsao_fechamento;
        this.infoOrcamento.contato = data.orcamento.contato;
        this.infoOrcamento.bo_aceite_informacoes_orcamento = this.normalizarAceiteInformacoesOrcamento(data.orcamento.bo_aceite_informacoes_orcamento);

        this.clientBasicInfo = data.cliente || new Object();
        if (data.cliente && data.cliente.cnpj) {
          this.$store.state.orcamento.dados.pessoaFisica = data.cliente.cnpj.length === 11;
        }
        this.alertasCompleta = {
          alertasDeMudanca: data.alertasDeMudanca,
          alertasMudancaEstoques: data.alertasMudancaEstoques,
          alertasMudancaPrecoMinimo: data.alertasMudancaPrecoMinimo,
          alertasMultiplos: data.alertasMultiplos,
        };
        this.opcoesPagamentos = data.opcoes_pagamentos != null ? data.opcoes_pagamentos : null;
        if (this.$store.state.orcamento.dados.cd_filial == 1) {
          this.$store.commit(
            "carrinho/CURRENT_CLIENT",
            data.orcamento.cliente_codigo
          );
        } else {
          this.$store.commit(
            "carrinhoitj/CURRENT_CLIENT_ITJ",
            data.orcamento.cliente_codigo
          );
        }
      } catch (e) {
        this.$helper.showErrorResponse(e);
      } finally {
        const decorrido = Date.now() - iniciadoEm;
        const restante = Math.max(0, 5000 - decorrido);
        await new Promise(r => setTimeout(r, restante));
        this.processoCarregamento = false;
      }
    },
    montarAlertasItem(item) {
      if (!this.alertasCompleta) return null;

      const produtoCodigo = item.produto_codigo;
      const produtoKey = String(produtoCodigo);
      const pegarAlertaPorProduto = (mapa) => {
        if (!mapa || typeof mapa !== "object" || Array.isArray(mapa)) return null;
        return mapa[produtoCodigo] || mapa[produtoKey] || null;
      };

      const alertasDeMudanca = this.alertasCompleta.alertasDeMudanca;
      let mudanca = {};
      if (alertasDeMudanca && alertasDeMudanca !== true) {
        const diffs = pegarAlertaPorProduto(alertasDeMudanca);
        if (diffs) {
          mudanca = { [produtoKey]: diffs };
        }
      }

      const estoques = Array.isArray(this.alertasCompleta.alertasMudancaEstoques)
        ? this.alertasCompleta.alertasMudancaEstoques
        : [];
      const estoque = estoques.filter((e) => e.id == item.id);

      let preco_minimo = {};
      const precoMinimoItem = pegarAlertaPorProduto(this.alertasCompleta.alertasMudancaPrecoMinimo);
      if (precoMinimoItem) {
        preco_minimo = { [produtoKey]: precoMinimoItem };
      }

      let multiplos = {};
      const multiplosItem = pegarAlertaPorProduto(this.alertasCompleta.alertasMultiplos);
      if (multiplosItem) {
        multiplos = { [produtoKey]: multiplosItem };
      }

      return { mudanca, estoque, preco_minimo, multiplos };
    },
    async loadOrcamentoItens(orcamento_id) {
      if (orcamento_id == null || orcamento_id == 0) return;
      this.alertasCompleta = null;

      try {
        const response = await Orcamento.getOrcamentoItens(orcamento_id)
          
            this.orcamentoItens = response.data.data;
  
            this.orcamentoItens.forEach((el) => {
              el.ultimaMargem = {
                margemValor: el.margem_valor,
                margemPercentual: el.margem_percentual,
              };
            });
  
            if(this.orcamentoItens.length > 0){
              this.setarTabelapreco(this.orcamentoItens[0].cd_tabelapreco);
            }
  
            this.vlMinimoOrcamento = response.data.valor_unitario_total;
  
            this.validaTabelaCoorp(this.orcamentoItens);
            this.sincronizarValorTotal(
              this.orcamentoItens.reduce((total, item) => total + item.valor_total * 1, 0)
            );
      } catch (e) {
        if (e.response.status === 404) {
          this.productsVisible = true;
          return;
        }
        this.$helper.showErrorResponse(e);
      }
      finally{
          this.carregandoItensOrcamento = false;
        };
    },
    validaTabelaCoorp(value) {
      for (let i = 0; i < value.length; i++) {
        let valor_unit =
          value[i].valor_unitario +
          value[i].margem_valor +
          value[i].valor_ipi +
          value[i].valor_st;
        if (value[i].bo_registro == "false") {
          if (
            value[i].vl_liquido_tab_coorp != 0 &&
            value[i].vl_liquido_tab_coorp > valor_unit
          ) {
            this.valida = true;
          }
        }
        this.show = true;
      }
    },
    async loadClientBasicInfo(cliente_codigo) {
      if (cliente_codigo == null || cliente_codigo == 0) return;
      this.clientBasicInfo = new Object();
      
      const response = await Cliente.getBasicInfo(cliente_codigo)
      try {
        this.clientBasicInfo = response.data.data;
        this.$store.state.orcamento.dados.pessoaFisica = response.data.data.cnpj.length === 11;
      } catch (e) {
        this.$helper.showErrorResponse(e);     
      }  
    },
    charCount() {
      this.tamRest = 300 - this.motivoCancel.length;
    },
    onSortChanged() {},
    confirmDeleteItem(row) {
      if (!this.validarAceiteInformacoesObrigatorio()) {
        return;
      }

      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que deseja excluir o produto Nº." +
            row.produto_codigo +
            "?",
          this.getConfirmModalOptions()
        )
        .then((value) => {
          if (value) {
            let vue = this;
            Orcamento.deleteOrcamentoItem(row.orcamento_id, row.id)
              .then((response) => {
                this.$helper.showMsg(response.data.msg, response.data.type);
                let index = vue.orcamentoItens.findIndex((x) => x.id == row.id);
                vue.orcamentoItens.splice(index, 1);

                vue.productChangesReturned = 0;
                let list = [];

                vue.productsReturn.forEach((value, index) => {
                  if (value == row.id) {
                    vue.productsReturn.splice(index, 1);
                  }

                  if (
                    list.findIndex((item) => item == value) == -1 &&
                    value != row.id
                  ) {
                    list.push(value);
                  }
                });
                vue.productChangesReturned = list.length;
              })
              .catch((e) => {
                this.$helper.showErrorResponse(e);
              });
          }
        })
        .catch((err) => {
          this.$helper.showErrorResponse(err);
        });
    },
    confirmCancel() {
      Orcamento.cancelOrcamento(this.$store.state.orcamento.dados.id, this.motivoCancel)
        .then((response) => {
          this.$helper.showMsg(response.data.msg, response.data.type);
          this.$router.push("/vendas/orcamentos");
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        });
    },
    fechaModalCancel() {
      this.tamRest = 300;
      this.motivoCancel = "";
      $bvModal.hide("cancelConfirm");
    },
    confirmFixProduts() {
      if (!this.validarAceiteInformacoesObrigatorio()) {
        return;
      }

      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que atualizar os produtos do Orçamento Nº. " +
            this.$store.state.orcamento.dados.id +
            "?",
          this.getConfirmModalOptions()
        )
        .then((value) => {
          if (value) {
            this.$store.commit('ui/LOADING', true);
            Orcamento.updateProducts(this.$store.state.orcamento.dados.id)
              .then((response) => {
                this.hasProductChanges = false;
                this.loadOrcamentoItens(this.$store.state.orcamento.dados.id);
                this.$helper.showMsg(response.data.msg, response.data.type);
                this.productsReturn.splice(0, this.productsReturn.length);
              })
              .catch((e) => {
                this.$helper.showErrorResponse(e);
              })
              .finally(() => {
                this.$store.commit('ui/LOADING', false);
              })
              ;
          }
        })
        .catch((err) => {
          this.$helper.showErrorResponse(err);
        });
    },
    getValorComissao(item) {
      return item.valor_comissao;
    },
    async confirmSend() {
      if (this.efetivandoPedido) {
        return;
      }

      this.efetivandoPedido = true;

      if (!this.validarAceiteInformacoesObrigatorio()) {
        this.efetivandoPedido = false;
        return;
      }

      let statusCliente = this.clientBasicInfo.status;
      let orcamento = this.$store.state.orcamento.dados;
      let orcamentoOriginal = this.$store.state.orcamento.dadosOriginais;
      let itens = this.orcamentoItens;
      let ehValido = await ValidadorOrcamento.validarEnvioOrcamento(statusCliente, orcamento, itens, this.infoOrcamento, orcamentoOriginal)

      if (!ehValido) {
        this.efetivandoPedido = false;
        return;
      }

      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que deseja enviar Orçamento Nº. " +
            orcamento.id +
            ", depois de enviado não será mais possível alterá-lo?",
          this.getConfirmModalOptions()
        )
        .then((value) => {
          if (value) {
            this.sendOrcamento();
          } else {
            this.efetivandoPedido = false;
          }
        })
        .catch((err) => {
          this.efetivandoPedido = false;
          this.$helper.showErrorResponse(err);
        });
    },
    getVariant() {
      return this.$store.state.orcamento.dados.cd_filial == 1 ? "primary" : "warning";
    },
    getFilial() {
      return this.$store.state.orcamento.dados.cd_filial == 1 ? "Maringá - PR" : "Navegantes - SC";
    },
    permiteInserirOuEditarItem(){
      let dadosParaValidacao = {id_forma: this.$store.state.orcamento.dadosOriginais.id_forma, id_condicao: this.$store.state.orcamento.dadosOriginais.id_condicao};
      dadosParaValidacao = Object.assign(dadosParaValidacao, this.infoOrcamento);

      return ValidadorOrcamento.existeAlteracoesNaoSalvas(this.$store.state.orcamento.dados, dadosParaValidacao) ? false : true;
    },
    salvarOrcamento() {
      if (!this.validarAceiteInformacoesObrigatorio()) {
        return;
      }

      let orcamento = this.$store.state.orcamento.dados;
    
      if(this.orcamentoEstaModoEdicao && ValidadorOrcamento.existeAlteracoesNaoSalvas(orcamento, this.infoOrcamento)){
        this.atualizarInfoOrcamento();
      }

      Orcamento.saveOrcamento(orcamento, this.$store.state.orcamento.dados.cd_filial)
        .then((response) => {
          this.$helper.showMsg(response.data.msg);
          this.$store.commit("orcamento/SALVAR_ORCAMENTO_ORIGINAL", Object.assign({}, orcamento));
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        });
    },
    sendOrcamento() {
      if (this.$store.state.ui.salvandoPedido) {
        return;
      }

      this.efetivandoPedido = true;
      this.$store.commit('ui/SALVANDO_PEDIDO', true);

      let data = {
        orcamento: this.$store.state.orcamento.dados,
        itens: this.orcamentoItens,
        cd_filial: this.$store.state.orcamento.dados.cd_filial,
        valor_total: this.valorTotalSum,
      };

      this.$store.commit('ui/LOADING_MSG', "Enviando Pedido de Venda…");

      const pedidoData = Pedido.criarPedidoData(data)

      Orcamento.sendOrcamento(this.$store.state.orcamento.dados.id, pedidoData)
        .then((response) => {
          this.$helper.showMsg('Pedido enviado com sucesso!', 'success');
          Analytics.trackPurchase({
            idPedido: pedidoData.codigo || this.$store.state.orcamento.dados.id,
            valorTotal: this.valorTotalSum,
            itens: this.orcamentoItens,
            cd_filial: this.$store.state.orcamento.dados.cd_filial
          }, this.$store);
          this.$router.push("/vendas/orcamentos");

        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        }).finally(() => {
          this.efetivandoPedido = false;
          this.$store.commit('ui/LOADING_MSG', "");
          this.$store.commit('ui/SALVANDO_PEDIDO', false);
        });
    },
    salvarPedido() {
      if (!this.validarAceiteInformacoesObrigatorio()) {
        return;
      }

      let data = {
        orcamento: this.$store.state.orcamento.dados,
        itens: this.orcamentoItens,
        cd_filial: this.$store.state.orcamento.dados.cd_filial,
        valor_total: this.valorTotalSum,
      };

      Pedido.salvePedido(data)
      .then((response) => {
        this.$helper.showMsg('Pedido enviado com sucesso!', 'success');
        this.$router.push("/vendas/orcamentos");
      })
      .catch((e) => {
        this.$helper.showErrorResponse('');
      })
      .finally(() => {
        this.$store.commit('ui/SALVANDO_PEDIDO', false);
      });
    },
    async editBudgetItem(item) {
      if (!this.validarAceiteInformacoesObrigatorio()) {
        return;
      }

      if(this.valorTotalSum >= VALOR_MINIMO_FORMA_PGTO && !this.permiteInserirOuEditarItem()){
        let continuar = await this.confirmarSeProssegueAcao();

        if(!continuar){
          return;
        }
      }

      this.currentOrcamentoItem = Object.assign({}, item);
      this.$bvModal.show(this.$refs.orcamentoItemEdit.id);
    },
    async onItemSaved(item) {
      this.itensAlterados = true;
      await this.loadOrcamentoItens(this.orcamento_id)
      this.itensAlterados = false;
    },
    printOrcamento() {
      this.$store.commit('ui/LOADING_MSG', "Gerando proposta do orçamento...");
      Orcamento.printOrcamento(this.$store.state.orcamento.dados.id)
        .then((response) => {
          let fileURL = window.URL.createObjectURL(
            new Blob([response.data], {
              type: "application/pdf",
            })
          );
          let windowPrint = window.open(fileURL, "about:blank");
          if(!windowPrint || windowPrint.closed || typeof windowPrint.closed=='undefined') 
          { 
            return this.$toast.error({
                        message: "Seu navegador bloqueou uma janela pop-up. Para continuar, por favor, permita pop-ups para este site.",
                        showMethod: 'swing',
                        timeOut: 8000,
                        progressBar: true,
                        errorColor: '#dc3545'});
          };
          windowPrint.onload = function () {
            windowPrint.print();
          };
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        }).finally(() => {
          this.$store.commit('ui/LOADING_MSG', "");
        })
    },
    isAdding(produto_codigo = null) {
      if (produto_codigo == null) return this.adding.length > 0;
      else return this.adding.includes(produto_codigo);
    },
    onAddMga(data) {
      this.onAdd(data);
    },
    onAddItj(data) {
      this.onAdd(data);
    },
    onAdd(data) {
      if (!this.validarAceiteInformacoesObrigatorio()) {
        return;
      }

      this.onStartAdding(data.codigo);
      let addItem = {
        produto_codigo: data.codigo,
        quantidade: data.quantidade,
        cd_filial: this.$store.state.orcamento.dados.cd_filial,
        cd_empresa: 1,
      };
      Orcamento.addOrcamentoItem(this.$store.state.orcamento.dados.id, addItem)
        .then((response) => {
          let newItem = response.data.data;
          newItem.titulo = data.titulo;
          newItem.valor_bruto_unit =
            newItem.valor_unitario * 1 +
            newItem.valor_ipi * 1 +
            newItem.valor_st * 1 +
            newItem.margem_valor * 1;
          newItem.valor_total =
            newItem.quantidade * 1 * newItem.valor_bruto_unit;
          let index = this.orcamentoItens.findIndex((x) => x.id == newItem.id);
          if (index > -1) {
            this.$set(this.orcamentoItens, index, newItem);
          } else {
            this.orcamentoItens.push(newItem);
          }
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        })
        .finally(() => {
          this.onEndAdding(data.codigo);
        });
    },
    onStartAdding(produto_codigo) {
      this.adding.push(produto_codigo);
    },
    onEndAdding(produto_codigo) {
      this.adding = this.adding.filter(function (value) {
        return value != produto_codigo;
      });
    },
    async showProducts() {
      if (!this.validarAceiteInformacoesObrigatorio()) {
        return;
      }

      if(this.valorTotalSum >= VALOR_MINIMO_FORMA_PGTO && !this.permiteInserirOuEditarItem()){
        let continuar = await this.confirmarSeProssegueAcao();

        if(!continuar){
          return;
        }
      }

      this.$store.state.carrinho.cliente_codigo = this.$store.state.orcamento.dados.cliente_codigo;
      this.productsVisible = true;
    },
    hideProducts() {
      location.reload();
      this.productsVisible = false;
    },
    getConfirmModalOptions(overrides = {}) {
      return {
        title: "Atenção",
        size: "sm",
        centered: true,
        hideHeaderClose: false,
        contentClass: "orcamento-confirm-modal",
        headerClass: "orcamento-confirm-modal__header",
        bodyClass: "orcamento-confirm-modal__body",
        footerClass: "orcamento-confirm-modal__footer",
        okVariant: "orcamento-confirm-ok",
        cancelVariant: "orcamento-confirm-cancel",
        okTitle: "Sim",
        cancelTitle: "Não",
        ...overrides,
      };
    },
    async confirmarSeProssegueAcao() {
      return await this.$bvModal.msgBoxConfirm(
        "Existem campos obrigatórios não preenchidos. Se continuar, você poderá perder dados não salvos. Deseja prosseguir?",
        this.getConfirmModalOptions()
      );
    },
    alteraPrevFechamento() {
      const data_prev = new Date(this.infoOrcamento.previsao_fechamento);
      const data_atual = new Date();
      data_atual.setUTCHours(0, 0, 0, 0);
      if (data_prev.getTime() < data_atual.getTime()) {
        this.$helper.showMsg(
          "A data de previsão de fechamento não pode ser menor que a data atual.",
          "warning"
        );
        return;
      }
    },   
    voltarOrcamentos() {
      this.$router.push("/vendas/orcamentos");
    },
    duplicarOrcamento() {
      Orcamento.duplicarOrcamento(this.$store.state.orcamento.dados)
        .then((response) => {
          this.$helper.showMsg(response.data.msg, response.data.type);
        })
        .catch((e) => {
          this.$helper.showErrorResponse(e);
        });
    },
    setarTabelapreco(cd_tabelapreco){
      if(!this.infoOrcamento.cd_tabelapreco){
        this.infoOrcamento.cd_tabelapreco = cd_tabelapreco;
      }
      
    }
  },
  beforeDestroy() {
    EventBus.$off("sendOrcamento", this.sendOrcamento);
  },
};
</script>
